import gql from "graphql-tag";

export const CREATE_INVENTORY_ENTRY_MUTATION = gql`
  mutation($params: CreateInventoryEntryParams!) {
    createInventoryEntry(params: $params) {
      id
    }
  }
`;

export const UPDATE_INVENTORY_ENTRY_MUTATION = gql`
  mutation($id: Int!, $params: UpdateInventoryEntryParams!) {
    updateInventoryEntry(id: $id, params: $params) {
      id
    }
  }
`;

export const CLEAR_INVENTORY_LOCATION_QUANTITIES_MUTATION = gql`
  mutation($id: Int!) {
    clearInventoryLocationQuantities(id: $id) {
      id
    }
  }
`;

export const REGULARIZE_INVENTORY_LOCATION_QUANTITY_MUTATION = gql`
  mutation($id: Int!, $inventoryItemId: Int!, $quantity: Float!) {
    regularizeInventoryLocationQuantity(
      id: $id,
      inventoryItemId: $inventoryItemId,
      quantity: $quantity
    ) {
      id
    }
  }
`;
